import Widget               from "lib/widget";
import AjaxFileForm         from "servos/ajaxFileForm";
import { initBootstrapComponents } from "lib/bootstrapTooltips";
import uuid                 from 'uuid/v4';
import GeocompletedAddress  from 'widgets/geocompletedAddress'
import { withGooglePlaces } from 'servos/googlePlaces'

class LetterWidget extends Widget {
  bind() {
    this.modalContainer = this.root.find('#checklist-modal-container');
    this.checklistsRoot = this.root.find('#checklists-main-tab');
    bindLetterModal.call(this);
    hookCocoonToAssignUniqueIdsToNestedFields.call(this);
    toggleTypeOfItem.call(this)
  }
}

let toggleTypeOfItem = function() {
  this.root.find('.result-radio').on('change', (e) => {
    if (["unsatisfactory", "satisfactory_minor"].includes(e.target.value)) {
      $('.non-compliant-fields').removeClass('d-none')
    } else {
      $('.non-compliant-fields').addClass('d-none')
    }
  })
}

let bindLetterModal = function() {
  this.checklistsRoot.on('click', '.edit-location', (e) => {
    let locationUrl = getOrBuildUrl.call(this, e)
    $.ajax({
      url: locationUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.formElem = this.modalContainer.find('form');
      this.modalContainer.find('.modal').on('shown.bs.modal', (e) => {
        console.log("NOW I'M VISIBLE")
        bindAjaxForm.call(this)
        this.emit('form-loaded')
      })
      this.modalContainer.find('.modal').modal('show');
    })
  })
}

let bindAjaxForm = function() {
  this.ajaxForm = new AjaxFileForm(this.formElem)
  this.ajaxForm.on('success', updateItemRow.bind(this))
  this.ajaxForm.on("error",   errorResponse.bind(this))
  assignUniqueIdsToNestedFields.call(this)
  bindAddressLocator.call(this);
};

// update item row
let updateItemRow = function(response) {
  let itemRow = this.checklistsRoot.find(`.checklist-item[data-item-id=${response.data.item.id}]`)
  itemRow.replaceWith(response.data.item.html);
  initBootstrapComponents(this.checklistsRoot);
  this.root.find('#general-badge').html(response.data.project.outstanding_general_badge)
  this.root.find('#project-checklist-labels').html(response.data.project.checklist_labels)
  this.modalContainer.find('.modal').modal('hide');
  this.emit('item-updated')
}

// this widget is shared with the external pages.
// For external pages we don't pass the url but the item id instead.
let getOrBuildUrl = function(e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/letter_location_modal`
  }
}

let hookCocoonToAssignUniqueIdsToNestedFields = function() {
  $(document).on('cocoon:after-insert', () => {
    assignUniqueIdsToNestedFields.call(this)
    bindAddressLocator.call(this)
  })
}

let assignUniqueIdsToNestedFields = function() {
  $(".nested-fields").each((index, ele) => {
    const id = uuid()
    const trigger = $(ele).find(".address-fields-trigger")
    const fields = $(ele).find(".address-fields")
    $(trigger).attr("href", `#${id}`)
    $(fields).attr("id", id)
  })
}

let bindAddressLocator = function(e) {
  let nestedFields = this.root.find('form .nested-fields')
  withGooglePlaces(() => {
    _.each(nestedFields, (locationField) => {
      new GeocompletedAddress({
        root: $(locationField),
        options: {
          types: ['address'],
          country: 'AU'
        }
      });
    })
  })
};

let errorResponse = function(response) {
  this.formElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindAjaxForm.call(this);
  this.emit('form-loaded');
}

export default LetterWidget
